/**
 * The three date formats the landscapes use, so a timestamp reads the same on every screen:
 *   fmtDate      "Oct 22, 2026"            ledger cells, cards
 *   fmtDateTime  "Oct 22, 2026 · 2:31 PM"  tooltips, detail rows, "last run" cells
 *   fmtRelative  "3 days ago"              (pair with fmtDateTime in a title)
 * Before this, one screen showed "October 22, 2026 · 2:31 PM", the next "Oct 22 26" and a third
 * "10/22 2:31 PM". Locale is pinned to en-US like the older helpers in Utils/index.js.
 */
const toDate = (v) => {
  if (v == null || v === '') return null;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const fmtDate = (v, empty = '—') => {
  const d = toDate(v);
  return d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : empty;
};

export const fmtTime = (v, empty = '—') => {
  const d = toDate(v);
  return d ? d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : empty;
};

export const fmtDateTime = (v, empty = '—') => {
  const d = toDate(v);
  return d ? `${fmtDate(d)} · ${fmtTime(d)}` : empty;
};

export const fmtRelative = (v, now = Date.now(), empty = '—') => {
  const d = toDate(v);
  if (!d) return empty;
  const diff = Math.max(0, now - d.getTime());
  const min = Math.round(diff / 60000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min} min ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr} hour${hr === 1 ? '' : 's'} ago`;
  const day = Math.round(hr / 24);
  if (day < 30) return `${day} day${day === 1 ? '' : 's'} ago`;
  const month = Math.round(day / 30);
  if (month < 12) return `${month} month${month === 1 ? '' : 's'} ago`;
  const year = Math.round(month / 12);
  return `${year} year${year === 1 ? '' : 's'} ago`;
};
